var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1Cm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 210.148C165.228 210.148 210 165.376 210 110.148C210 54.9192 165.228 10.1477 110 10.1477C54.7715 10.1477 10 54.9192 10 110.148C10 165.376 54.7715 210.148 110 210.148ZM110 120.148C115.523 120.148 120 115.671 120 110.148C120 104.625 115.523 100.148 110 100.148C104.477 100.148 100 104.625 100 110.148C100 115.671 104.477 120.148 110 120.148Z",
    fill: "#CC9B92",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110.148,
    r: 10,
    stroke: "#37A851",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Cm);
export default __webpack_public_path__ + "static/media/1cm.2e2fc71d4380be5678aece33fe372399.svg";
export { ForwardRef as ReactComponent };